import request from '../request';
import { ServerSettings } from '../../types/Settings';
import { SETTINGS } from '../endpoints';

export interface TeacherClassManagementSetting {
  rescheduleClassAllowed: boolean;
  updateClassroomAllowed: boolean;
}

const TEACHER_CLASS_MANAGEMENT_ENDPOINT =
  'lessons/teacher-class-management-setting';

export function getTeacherClassManagementSetting() {
  return request<TeacherClassManagementSetting>(
    TEACHER_CLASS_MANAGEMENT_ENDPOINT,
  );
}

/**
 * Obtiene la fecha y hora del server con su offset segun la config de la univ
 */
export const getServerTimezone = () => {
  const url = SETTINGS.TIMEZONE;
  return request<ServerSettings>(url);
};
